/* eslint-disable array-callback-return */
import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import React from "react";
import ImageUploading from "react-images-uploading";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { useTranslation } from "react-i18next";
// import { IHotel } from "../../../utils/HotelInterface";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: theme.spacing(5),
        },
        uploadFile: {
            width: "100%",
            background: "antiquewhite",
            padding: "14px",
            minHeight: "6em",
            marginBottom: "16px",
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 18,
            borderRadius: 8,
        },
        changeImage: {
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 14,
        },
    })
);

export function MutiplePhoto(props: { handleChangePhotos: (e: any) => void }) {
    const [images, setImages] = React.useState([]);
    const maxNumber = 69;

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])

    const onChange = (imageList: any, addUpdateIndex: any) => {
        // data for submit
        setImages(imageList);
        const imageFiles: any = [];
        imageList.map((image: any) => {
            imageFiles.push(image.file);
        });
        props.handleChangePhotos(imageFiles);
    };

    const classes = styles();

    const { t } = useTranslation();

    return (
        <Grid container>
            <Grid item lg={12} sm={12} xs={12}>
                <div className={classes.inpuText}>
                    <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                    >
                        {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                        }) => (
                            // write your building UI
                            <div className="upload__image-wrapper">
                                <label htmlFor="contained-button-file">
                                    <Button
                                        className={classes.uploadFile}
                                        variant="text"
                                        component="span"
                                        style={
                                            isDragging
                                                ? { color: "red" }
                                                : undefined
                                        }
                                        onClick={onImageUpload}
                                        {...dragProps}
                                    >
                                        <PhotoCamera
                                            style={{ marginRight: 20 }}
                                        />
                                        {t("propriete.labels.photos")}
                                    </Button>
                                </label>
                                &nbsp;
                                <Button
                                    style={{
                                        fill: "#d04343",
                                        color: "#d04343",
                                        textTransform: "initial",
                                    }}
                                    onClick={onImageRemoveAll}
                                >
                                    <Delete style={{ marginRight: 20 }} />{" "}
                                    {t(
                                        "propriete.labels.supprimerTousLesPhotos"
                                    )}
                                </Button>
                                <ImageList
                                    sx={{ maxHeight: 500 }}
                                    cols={3}
                                    rowHeight={360}
                                    gap={12}
                                >
                                    {imageList.map((image, index) => (
                                        <ImageListItem key={index}>
                                            <img
                                                src={`${image["data_url"]}}`}
                                                srcSet={`${image["data_url"]}`}
                                                alt=""
                                                loading="lazy"
                                            />
                                            <div className="image-item__btn-wrapper">
                                                <Button
                                                    variant="outlined"
                                                    onClick={() =>
                                                        onImageUpdate(index)
                                                    }
                                                    className={
                                                        classes.changeImage
                                                    }
                                                >
                                                    {t(
                                                        "propriete.labels.changer"
                                                    )}
                                                </Button>

                                                <Button
                                                    variant="outlined"
                                                    style={{
                                                        fill: "#d04343",
                                                        color: "#d04343",
                                                    }}
                                                    onClick={() =>
                                                        onImageRemove(index)
                                                    }
                                                >
                                                    <Delete />
                                                </Button>
                                            </div>
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </div>
                        )}
                    </ImageUploading>
                </div>
            </Grid>
        </Grid>
    );
}
